import React, { useEffect, useState } from 'react';
import css from './TerminalCTA.module.scss';

import { PrismicButton } from '@components/Button/Button';
import { TNS } from '../../config';
import constructURLWithQueryParams from '@utils/constructURLWithQueryParams';
import useLocalStorageValues from '@utils/useLocalStorageValues';

const PerksList = props => {
  return <ul>{props.children}</ul>;
};

const PerkIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.51256313.5811083l-5.58976181 7.933417L2.33557206 6.927296c-.5342053-.5342053-1.40103275-.5342053-1.93523805 0-.53406573.5381641-.53406573 1.4039156.00172438 1.936958l2.73521435 2.7352188c.25715033.2571503.60503276.4008645.96761902.4008645.44238249 0 .86085955-.2136983 1.11883744-.5797298l6.5266379-9.2636151c.435016-.6196901.2871251-1.473354-.3318215-1.907902-.6181203-.434409-1.47107004-.2861595-1.90598247.3320179zm-5.58976181 7.933417l-.64839332.9202493 1.44440609-.1242365-.79601277-.7960128zm6.40717328-6.7144992l.5439982-.7756694-.5439982.7756694z"
        fill="#2ECC71"
        fillRule="nonzero"
      />
    </svg>
  );
};

const Perk = props => {
  return (
    <li>
      <PerkIcon /> {props.name}
    </li>
  );
};

const TerminalCTA = props => {
  const [tnsURL, setTnsURL] = useState(TNS.START_BUILDING_URL);
  const { rfsn, referrer, firstPageVisited } = useLocalStorageValues();

  useEffect(() => {
    setTnsURL(
      constructURLWithQueryParams(TNS.START_BUILDING_URL, rfsn, referrer, firstPageVisited)
    );
  }, [rfsn, referrer, firstPageVisited]);

  return (
    <div className="TerminalCTA-module">
      <section className={css.start_building}>
        {props.hideEyebrow ? null : (
          <p className={css.eyebrow}>{props.eyebrow || 'Start your 14-day free trial'}</p>
        )}
        <h2 className={props.titleClassName || css.h2}>
          {props.title || 'Create a marketplace today!'}
        </h2>
        <PerksList>
          <Perk name={props.perkOne || 'Launch quickly, without coding'} />
          <Perk name={props.perkTwo || 'Extend infinitely'} />
          <Perk name={props.perkThree || 'Scale to any size'} />
        </PerksList>
        <PrismicButton
          to={props.ctaButtonTo || tnsURL}
          className={css.CTAbutton}
          analyticsEvent="custom-sharetribe-account-started"
          analyticsProperties={{ position: 'terminal-cta' }}
        >
          {props.ctaButton || 'Start free trial'}
        </PrismicButton>
        {props.hideBelowButton ? null : (
          <p className={css.belowButton}>{props.eyebrow || 'No credit card required'}</p>
        )}
      </section>
      <div className={css.bleed}></div>
    </div>
  );
};

export default TerminalCTA;
